import Button from 'components/UI/Button';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import { BRAND_CONSTANTS } from 'constants/brands';
import { GENERAL_CONSTANTS } from 'constants/general';
import { Role } from 'data/User';
import { PermissionCode } from 'data/UserPermissions';
import { FontWeight } from 'lib/styles';
import React from 'react';
import styled from 'styled-components';
import { Main } from 'styles/themeColors';

const Heading = styled.span<any>`
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: ${FontWeight.bold};
`;

interface Props {
    onCreate: () => void;
    userRole: string;
}

const BrandHeader: React.FC<Props> = ({ onCreate, userRole }: Props) => {
    
    const isVendorOnlyUser = userRole === Role.Vendor; 

    return (
        <FlexboxContainerComponent justifyContent='space-between' width='100%' alignItems='center'>
            <Heading className='heading'>{GENERAL_CONSTANTS.BRANDS}</Heading>
            {
                !isVendorOnlyUser &&
                <FlexboxContainerComponent gap='8px'>
                    <Button
                        onClick={() => onCreate()}
                        bgColor={Main.brandDark}
                        borderColor={Main.brandDark}
                        permissionCode={PermissionCode.BRANDS_VIEW_CREATE_DELETE}
                    >
                        {BRAND_CONSTANTS.CREATE_BRAND}
                    </Button>
                </FlexboxContainerComponent>
            }
        </FlexboxContainerComponent>
    );
};

export default React.memo(BrandHeader);